module.exports = __webpack_public_path__ + "media/newstyle/images/Logo_ESP_ROXO-3867c545137bfb7270739c2eb9cf6d5c.png";